import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    List,
    ListItem,
    Container,
    Paper,
} from "@mui/material";

function AutomatedTesting() {
    const [automated, setAutomated] = useState([]);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/testing/automated_testing.txt",
        }).then((res) => {
            setAutomated(res.data);
        });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Box id="automatedtesting" sx={{ mt: 8, mb: 6 }}>
                {/* Title */}
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    Automated Testing
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", mt: 4 }}>
                    {automated &&
                        automated.map((data, index) => (
                            <Box key={index} sx={{ mb: 3, textAlign: "justify" }}>
                                {Array.isArray(data) ? (
                                    <Box>
                                        <Typography
                                            variant="h6"
                                            sx={{ color: "#030366", mb: 1, fontWeight: 600 }}
                                        >
                                            Benefits of automated testing:
                                        </Typography>
                                        <List>
                                            {data.map((subItem, subIndex) => (
                                                <ListItem
                                                    key={subIndex}
                                                    sx={{
                                                        fontFamily: "Raleway, sans-serif",
                                                        display: "list-item",
                                                        pl: 2,
                                                    }}
                                                >
                                                    {subItem}
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        sx={{ fontFamily: "Raleway, sans-serif" }}
                                    >
                                        {data}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                </Box>

            </Box>
        </Container>
    );
}

export default AutomatedTesting;
